export default "__VITE_ASSET__C59IM3D3__"